import { FC } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

const chatScreen: FC = () => {
  return (
    <Box sx={{ flex: 1, height: "100%", display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
      <Outlet />
    </Box>
  );
};

export default chatScreen;
